import { FC, ReactElement } from 'react';
import { Stack, Typography } from '@mui/material';

interface CardHeaderProps {
  title: string | ReactElement[];
  subheaders?: (string | ReactElement)[];
}

const CardHeader: FC<CardHeaderProps> = (props) => {
  const { title, subheaders } = props;

  return (
    <Stack sx={styles.container}>
      {Array.isArray(title) ? (
        title.map((TitleComponent, idx) => {
          const typeKey = `${TitleComponent.key}-${idx}`;

          return (
            <Typography key={typeKey} variant="h5" component="h3">
              {TitleComponent}
            </Typography>
          );
        })
      ) : (
        <Typography variant="h5" component="h3">
          {title}
        </Typography>
      )}

      {subheaders?.map((subheader, idx) => {
        const key =
          typeof subheader === 'string' ? `${subheader}-${idx}` : subheader.key;

        return (
          <Typography key={key} variant="body2" color="text.secondary">
            {subheader}
          </Typography>
        );
      })}
    </Stack>
  );
};

const styles = {
  container: {
    padding: '1rem 0 .25rem 0',
    textAlign: 'center',
  },
};

export { CardHeader };
